import { Flex, Select } from 'antd';
import { type FC, useState } from 'react';
import { IconTag } from 'src/components/Icon';
import { useStore } from 'src/store/reducers';

const { Option } = Select;

interface Props {
  setSelectedTag: (value: string | null) => void;
}

export const TagSelect: FC<Props> = ({ setSelectedTag }) => {
  const [search, setSearch] = useState<string>('');
  const trackerTags = useStore((s) => s.trackers.trackerTags);

  const tagExists = Array.from(trackerTags.values()).some((value) =>
    value.label?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <Select
      placeholder="Please select tag"
      optionLabelProp="label"
      showSearch
      onSearch={(value) => setSearch(value)}
      onSelect={(_value, option) => {
        setSelectedTag(option.key);
      }}
      style={{ width: '250px' }}
      allowClear
      onClear={() => setSelectedTag(null)}
    >
      {Array.from(trackerTags.entries()).map(([_key, value]) => (
        <Option key={value.id.toHexString()} value={value.label} label={value.label}>
          <Flex align={'center'} gap={'5px'} justify={'flex-start'}>
            <IconTag color={value.color} />
            {value.label}
          </Flex>
        </Option>
      ))}
      {!tagExists && search && (
        <Option key={search} value={search} label={search}>
          <Flex align={'center'} gap={'5px'}>
            <div>Create tag:</div>
            <div style={{ fontWeight: 'bold' }}>{search}</div>
          </Flex>
        </Option>
      )}
    </Select>
  );
};
